import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { ProjectConfigProvider } from './contexts/ProjectConfigContext';
import App from './App';
import 'bootstrap/dist/css/bootstrap.css';

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Router>
      <ProjectConfigProvider>
        <App />
      </ProjectConfigProvider>
    </Router>
  </React.StrictMode>
);